import { inject, Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

@Injectable({ providedIn: 'root' })


export class AuthStateService {  
  msalService = inject(MsalService);

  isReady = false;

  get userRoles(): ReadonlyArray<string> {
    const account = this.msalService.instance.getActiveAccount();
    return (account?.idTokenClaims as any)?.roles ?? [];
  }

  hasAccess(required: ReadonlyArray<string>): boolean {
    if (!required || required.length === 0) {
      return true;
    }

    return required.some(role => this.userRoles.includes(role));
  }

  get isAuthenticated(): boolean {
    return this.msalService.instance.getAllAccounts().length > 0;
  }
}
